// API: на бою — тот же origin, что отдал страницу.
// pro1618.ru обслуживает наш RU-прокси (VPS → nginx → emergent.host), который
// проксирует и сайт, и /api: запросы идут по тому же каналу, по которому
// страница уже успешно загрузилась — это важно для сетей, где пулы Cloudflare
// задушены ТСПУ. emergent.host тоже обслуживает свой /api. Превью/локально —
// по-прежнему из .env, чтобы тестирование не ходило в боевую базу.
const PROD_HOSTS = ["pro1618.ru", "emergent.host"];

const isProdPage =
  typeof window !== "undefined" &&
  PROD_HOSTS.some((d) => window.location.hostname === d || window.location.hostname.endsWith("." + d));

export const BACKEND_URL = isProdPage ? window.location.origin : process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
